import { RouteMenus, RoutePaths } from 'routes/route.roles';
import { ApplicationStep } from 'services/applicant/applicant.service.class';
import { NavMenuItem } from './navmenu.service';

export const ApplicationSubmenus: NavMenuItem[] = [
    {
        MenuID: RouteMenus.AppStatus,
        MenuText: 'Application Status',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ApplicationStatus,
        Route: RoutePaths.ApplicationStatus,
    },
    {
        MenuID: RouteMenus.AppPersonalInfo,
        MenuText: 'Personal Information',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.PersonalInfo,
        Route: RoutePaths.PersonalInfo,
    },
    {
        MenuID: RouteMenus.AppContactInfo,
        MenuText: 'Contact Information',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ContactInfo,
        Prerequisites: ApplicationStep.PersonalInfo,
        Route: RoutePaths.ContactInfo,
    },
    {
        MenuID: RouteMenus.AppAppType,
        MenuText: 'Application Type',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ApplicationType,
        Prerequisites: ApplicationStep.PersonalInfo,
        Route: RoutePaths.ApplicationType,
    },
    {
        MenuID: RouteMenus.AppEdHistory,
        MenuText: 'Education History',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.EducationHistory,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.EducationHistory,
    },
    {
        MenuID: RouteMenus.AppTranscripts,
        MenuText: 'Transcripts/Credentials',
        DefaultEnabled: true,
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.TranscriptsUploads,
        Prerequisites: ApplicationStep.EducationHistory,
        Route: RoutePaths.Transcripts,
    },
    {
        MenuID: RouteMenus.AppEmpHistory,
        MenuText: 'Employment History',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.EmploymentHistory,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.EmploymentHistory,
    },
    {
        MenuID: RouteMenus.AppWorkPerf,
        MenuText: 'Work Performance',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.WorkPerformance,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.WorkPerformance,
    },
    {
        MenuID: RouteMenus.AppReferences,
        MenuText: 'References',
        DefaultEnabled: false,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.References,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.References,
    },
    {
        MenuID: RouteMenus.AppCriminalHistory,
        MenuText: 'Criminal History',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.CriminalHistory,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.CriminalHistory,
    },
    {
        MenuID: RouteMenus.AppApplicantSurvey,
        MenuText: 'Applicant Survey',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ApplicantSurvey,
        Prerequisites: ApplicationStep.PersonalInfo | ApplicationStep.ApplicationType,
        Route: RoutePaths.ApplicantSurvey,
    },
    {
        MenuID: RouteMenus.AppProfQual,
        MenuText: 'Professional Qualifications',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ProfessionalQualifications,
        Prerequisites: ApplicationStep.ApplicationType,
        Route: RoutePaths.ProfessioanlQualifications,
    },
    {
        MenuID: RouteMenus.AppCertification,
        MenuText: 'Certification',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.FloridaCertification,
        Route: RoutePaths.Certification,
    },
    {
        MenuID: RouteMenus.AppInstQual,
        MenuText: 'Instructional Qualifications',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.InstructionalQualifications,
        Route: RoutePaths.InstructionalQualifications,
    },
    {
        MenuID: RouteMenus.AppProfSanctions,
        MenuText: 'Professional Sanctions',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ProfessionalSanctions,
        Route: RoutePaths.Sanctions,
    },
    {
        MenuID: RouteMenus.AppSubjectAreaExams,
        MenuText: 'Subject Area Exams',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.SubjectAreaExams,
        Route: RoutePaths.SubjectAreaExams,
    },
    {
        MenuID: RouteMenus.AppSubjectAreaInterest,
        MenuText: 'Subject Area Interest',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.SubjectAreaInterest,
        Route: RoutePaths.SubjectAreaInterest,
    },
    {
        MenuID: RouteMenus.AppStudentTeaching,
        MenuText: 'Student Teaching',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.StudentTeaching,
        Route: RoutePaths.StudentTeaching,
    },
    {
        MenuID: RouteMenus.AppCustodialSurvey,
        MenuText: 'Custodial Survey',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.CustodialSurvey,
        Route: RoutePaths.CustodialSurvey,
    },
    {
        MenuID: RouteMenus.AppParaSurvey,
        MenuText: 'Paraprofessional Survey',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ParaSurvey,
        Route: RoutePaths.ParaSurvey,
    },
    {
        MenuID: RouteMenus.AppTeacherTransfer,
        MenuText: 'Teacher Transfer Information',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.TeacherTransfer,
        Route: RoutePaths.TeacherTransfer,
    },
    {
        MenuID: RouteMenus.AppResumesCoverLetters,
        MenuText: 'Resume & Cover Letter',
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        ApplicationStep: ApplicationStep.ResumesCoverLetters,
        Route: RoutePaths.ResumesCoverLetters,
    },
];
